import { SearchOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import { Button, Modal, Tooltip } from 'antd';
import React from 'react';
import EmployeeSelect from '@/modules/zy-hr/components/EmployeeSelect';
import { hrRoutes } from '@/modules/zy-hr/constants/routes';

export default function EmployeeSearch() {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Tooltip title="搜索员工">
        <Button
          type="text"
          icon={<SearchOutlined />}
          aria-label="搜索员工"
          onClick={() => setOpen(true)}
        />
      </Tooltip>
      <Modal
        title="搜索员工"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        destroyOnHidden
      >
        {open && (
          <EmployeeSelect
            required={false}
            label=""
            fieldProps={{
              onChange: (uuid: string) => {
                if (!uuid) return;
                setOpen(false);
                history.push(hrRoutes.employeeDetail(String(uuid)));
              },
            }}
          />
        )}
      </Modal>
    </>
  );
}
